import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { CognitoUserInterface } from '@aws-amplify/ui-components';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'core-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit {
  dashboard = {
    label: 'Dashboard',
    route: '/portal/dashboard',
    icon: 'analytics',
    access: [
      'SuperAdmin',
      'OperationsManager',
      'PrescriptionManager',
      'Prescription',
      'Fulfilment',
      'Viewer',
    ],
  };

  stocktake = {
    expanded: false,
    label: 'Stocktake',
    links: [
      {
        label: 'New Stocktake',
        route: '/portal/stocktake',
        icon: 'add',
        access: ['SuperAdmin', 'OperationsManager', 'Fulfilment'],
      },
      {
        label: 'Reports',
        route: '/portal/stocktake/report',
        icon: 'analytics',
        access: ['SuperAdmin', 'OperationsManager', 'Fulfilment', 'Viewer'],
      },
      {
        label: 'Live Stock view',
        route: '/portal/stocktake/location',
        icon: 'warehouse',
        access: [
          'SuperAdmin',
          'OperationsManager',
          'Fulfilment',
          'PrescriptionManager',
          'Prescription',
          'Viewer',
        ],
      },
    ],

    access: [
      'SuperAdmin',
      'OperationsManager',
      'Fulfilment',
      'PrescriptionManager',
      'Prescription',
      'Viewer',
    ],
  };

  prescription = {
    expanded: false,
    links: [
      {
        label: 'New Prescription',
        route: '/portal/submit',
        icon: 'add',
        access: [
          'SuperAdmin',
          'OperationsManager',
          'PrescriptionManager',
          'Prescription',
        ],
      },
      {
        label: 'Prescriptions',
        route: '/portal/prescriptions',
        icon: 'list',
        access: [
          'SuperAdmin',
          'OperationsManager',
          'PrescriptionManager',
          'Prescription',
          'Packaging',
          'Fulfilment',
          'Viewer',
        ],
      },
    ],
    access: [
      'SuperAdmin',
      'OperationsManager',
      'PrescriptionManager',
      'Prescription',
      'Packaging',
      'Fulfilment',
      'Viewer',
    ],
  };

  batch = {
    expanded: false,
    links: [
      {
        label: 'New batch',
        route: '/portal/batches/create',
        icon: 'add',
        access: ['SuperAdmin', 'OperationsManager', 'PrescriptionManager', 'Fulfilment'],
      },
      {
        label: 'Batches',
        route: '/portal/batches',
        icon: 'list',
        access: [
          'SuperAdmin',
          'OperationsManager',
          'PrescriptionManager',
          'Prescription',
          'Fulfilment',
          'Viewer',
        ],
      },
    ],
    access: [
      'SuperAdmin',
      'OperationsManager',
      'PrescriptionManager',
      'Prescription',
      'Fulfilment',
      'Viewer',
    ],
  };

  user = {
    expanded: false,
    links: [
      {
        label: 'New user',
        route: '/portal/users/create',
        icon: 'add',
        access: ['SuperAdmin', 'OperationsManager'],
      },
      {
        label: 'Users',
        route: '/portal/users',
        icon: 'list',
        access: ['SuperAdmin', 'OperationsManager'],
      },
    ],
    access: ['SuperAdmin', 'OperationsManager'],
  };

  individual = {
    expanded: false,
    links: [
      {
        label: 'New individual',
        route: '/portal/individuals/create',
        icon: 'add',
        access: ['SuperAdmin', 'OperationsManager', 'Prescription'],
      },
      {
        label: 'Individuals',
        route: '/portal/individuals',
        icon: 'list',
        access: [
          'SuperAdmin',
          'OperationsManager',
          'PrescriptionManager',
          'Prescription',
          'Viewer',
        ],
      },
    ],
    access: [
      'SuperAdmin',
      'OperationsManager',
      'PrescriptionManager',
      'Prescription',
      'Viewer',
    ],
  };

  company = {
    expanded: false,
    links: [
      {
        label: 'New company',
        route: '/portal/companies/create',
        icon: 'add',
        access: ['SuperAdmin', 'OperationsManager', 'Prescription'],
      },
      {
        label: 'Companies',
        route: '/portal/companies',
        icon: 'list',
        access: [
          'SuperAdmin',
          'OperationsManager',
          'PrescriptionManager',
          'Prescription',
          'Viewer',
        ],
      },
    ],
    access: [
      'SuperAdmin',
      'OperationsManager',
      'PrescriptionManager',
      'Prescription',
      'Viewer',
    ],
  };

  medicine = {
    expanded: false,
    links: [
      {
        label: 'New medicine',
        route: '/portal/medicine/create',
        icon: 'add',
        access: ['SuperAdmin', 'OperationsManager', 'Prescription'],
      },
      {
        label: 'Medicine',
        route: '/portal/medicine',
        icon: 'list',
        access: [
          'SuperAdmin',
          'OperationsManager',
          'PrescriptionManager',
          'Prescription',
          'Fulfilment',
          'Viewer',
        ],
      },
    ],
    access: [
      'SuperAdmin',
      'OperationsManager',
      'PrescriptionManager',
      'Prescription',
      'Fulfilment',
      'Viewer',
    ],
  };

  ordermedicine = {
    expanded: false,
    links: [
      {
        label: 'New order medicine',
        route: '/portal/order-medicine/create',
        icon: 'add',
        access: ['SuperAdmin', 'OperationsManager', 'Prescription', 'Fulfilment'],
      },
      {
        label: 'Order Medicine',
        route: '/portal/order-medicine',
        icon: 'list',
        access: [
          'SuperAdmin',
          'OperationsManager',
          'Prescription',
          'PrescriptionManager',
          'Fulfilment',
          'Viewer',
        ],
      },
    ],
    access: [
      'SuperAdmin',
      'OperationsManager',
      'Prescription',
      'PrescriptionManager',
      'Fulfilment',
      'Viewer',
    ],
  };

  systemManagement = {
    expanded: false,
    links: [
      {
        label: 'Logs',
        route: '/portal/logs',
        icon: 'history',
        access: ['SuperAdmin'],
      },
    ],
    access: ['SuperAdmin'],
  };

  /** Sage integration – admin only */
  sage = {
    expanded: false,
    label: 'Sage',
    links: [
      {
        label: 'Connection',
        route: '/portal/integrations',
        icon: 'sync_alt',
        access: ['SuperAdmin'],
      },
      {
        label: 'Create invoices',
        route: '/portal/integrations/invoices',
        icon: 'receipt',
        access: ['SuperAdmin'],
      },
    ],
    access: ['SuperAdmin'],
  };

  currentUser: CognitoUserInterface | null = null;
  currentRoles: Array<string>;
  /** Mirrors `environment.sageUiEnabled` for templates. */
  readonly sageUiEnabled = environment.sageUiEnabled;
  constructor(private _auth: AuthService) {}

  ngOnInit(): void {
    this._auth.currentRolesChanges().subscribe((roles) => {
      this.currentRoles = roles;
    });

    this._auth.currentUserChanges().subscribe((user) => {
      this.currentUser = user;
    });
  }

  async signOut() {
    await this._auth.signOut();
  }
}
